import { BaseFormService } from './base/base.form.service';
import {
  OrderItemFormService,
  OrderTotalFormService,
  OrderAddPendingFormService,
} from './orders';
import { TransferFormService } from './transfer/transfer.form.service';
import { TransferDestinationsFormService } from './transfer-destinations/transfer-destinations.form.service';
import { TransferTotalFormService } from './transfer/transfer-totals-form.service';
import { StandWorksheetFormService } from './stand-worksheet/stand-worksheet.form.service';
import { InventoryCountGroupFormService } from '@shared/services/inventory-count/inventory-count-group.form.service';
import { InventoryCountFormService } from './inventory-count/inventory-count.form.service';
import { TransferAutoRestockFormService } from '@shared/services/transfer-auto-restock/transfer-auto-restock.form.service';
import { TransferGroupFormService } from './transfer-group/transfer-group.form.service';
import { TransferGroupChildFormService } from './transfer-group-child/transfer-group-child.form.service';
import { TransferGroupAddFormService } from './transfer-group/transfer-group-add.form.service';
import { TransferGroupAutoRestockAddFormService } from './transfer-group-auto-restock/transfer-group-auto-restock-add.form.service';
import { TransferGroupAutoRestockFormService } from './transfer-group-auto-restock/transfer-group-auto-restock.form.service';
import { TransferGroupTemplateFormService } from './transfer-group-template/transfer-group-template.form.service';
import { HawkerProfileFormService } from './hawker-profile/hawker-profile.form.service';
import { HawkerSessionFormService } from './hawker-session/hawker-session.form.service';

export const ENTITY_FORM_SERVICES: any[] = [
  BaseFormService,
  OrderItemFormService,
  OrderAddPendingFormService,
  OrderTotalFormService,
  TransferTotalFormService,
  TransferFormService,
  TransferDestinationsFormService,
  TransferGroupChildFormService,
  StandWorksheetFormService,
  InventoryCountGroupFormService,
  InventoryCountFormService,
  TransferAutoRestockFormService,
  TransferGroupFormService,
  TransferGroupAddFormService,
  TransferGroupAutoRestockAddFormService,
  TransferGroupAutoRestockFormService,
  TransferGroupTemplateFormService,
  HawkerProfileFormService,
  HawkerSessionFormService,
];
